import { useLocation } from 'react-router-dom';
import { SilentUpdater } from '@/components/SilentUpdater';

// Rutas internas donde la actualización silenciosa PUEDE aplicarse
// (personal/admin dentro de la app). Fuera de estas rutas nunca se
// consulta /version.json ni se recarga, para no interrumpir a
// clientes en check-in ni generar tráfico en páginas públicas.
const ALLOWED_ROUTES = new Set([
  '/dashboard',
  '/clients',
  '/memberships',
  '/sales',
  '/expenses',
  '/inventory',
  '/classes',
  '/reports',
  '/employees',
  '/settings',
  '/gyms',
  '/users',
  '/webhooks',
  '/whatsapp',
  '/support',
]);

// Prefijos de rutas donde la actualización jamás debe consultarse ni aplicarse.
// Incluye las superficies de check-in (escáner, self check-in público,
// alta pública) y pantallas públicas/legales.
const BLOCKED_PREFIXES = ['/checkin/', '/join/', '/legal/'];

function isUpdateAllowedRoute(pathname: string): boolean {
  if (ALLOWED_ROUTES.has(pathname)) return true;
  if (BLOCKED_PREFIXES.some((prefix) => pathname.startsWith(prefix))) return false;
  return false;
}

export function RouteAwareUpdateBanner() {
  const { pathname } = useLocation();
  const isAllowed = isUpdateAllowedRoute(pathname);

  // Se monta siempre para que, al navegar entre rutas, el hook se reinicie;
  // con `enabled={false}` no hay polling ni recarga en rutas bloqueadas.
  return <SilentUpdater enabled={isAllowed} />;
}